var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMobiworkxSurveyIcon = function SvgMobiworkxSurveyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF4E00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "m8.941 11.097 3.46 3.57L23.932 2.767"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF4E00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M22.78 12.288v8.332a2.42 2.42 0 0 1-.676 1.683 2.27 2.27 0 0 1-1.63.697H4.33a2.27 2.27 0 0 1-1.631-.697 2.42 2.42 0 0 1-.676-1.683V3.957c0-.632.243-1.237.676-1.684a2.27 2.27 0 0 1 1.63-.697h12.685"
  })));
};
export default SvgMobiworkxSurveyIcon;